import { EnglishArabicDTO } from "bbsf-controls"
export class PermissionSetModel
{
      Id:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      OrganizationID :number
      PermissionIDs :number[]
      SysName :string
      OrganizationName :EnglishArabicDTO=new EnglishArabicDTO();  
}
     